import type { ReactNode } from 'react'

import { Tooltip } from '@mui/material'

import css from './CellTooltip.module.css'

interface CellTooltipProps {
	children: ReactNode
	className?: string
	content: string
	title?: string
}

export function CellTooltip({ children, className, content, title }: CellTooltipProps) {
	if (!content.trim()) {
		return <td className={className}>{children}</td>
	}

	const processText = (text: string): ReactNode => {
		return text.split('\n').map((line, index, array) => (
			<span key={index}>
				{line}
				{index < array.length - 1 && <br />}
			</span>
		))
	}

	const tooltipContent = (
		<div className={css.tooltipContent}>
			{title && <div className={css.tooltipTitle}>{title}</div>}
			<div>{processText(content)}</div>
		</div>
	)

	return (
		<Tooltip
			arrow
			enterDelay={500}
			leaveDelay={0}
			placement="bottom"
			slotProps={{
				tooltip: {
					className: css.muiTooltip
				}
			}}
			title={tooltipContent}
		>
			<td className={className}>
				{children}
			</td>
		</Tooltip>
	)
}
